import { AfterViewInit, Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
//import { latLng, tileLayer, circle, polygon, marker, icon, Layer } from 'leaflet';
import * as Leaflet from 'leaflet';
import { EventService } from 'src/app/core/services/event.service';
import { DevelopmentsService } from '../../../services/developments.services';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-address-developments',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressDevelopmentsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  addressForm: any;
  @Input()
  dataToFormInitAddress: any;
  subscription!: Subscription;
  subscriptionSubmitted!: Subscription;
  propertyAddressForm!: FormGroup;
  options: any;
  map!: Leaflet.Map;
  markers: Leaflet.Marker[] = [];
  countries: any = [];
  regions: any = [];
  districts: any = [];
  counties: any = [];
  parishes: any = [];
  @Input()
  submitted: boolean = false;
  lat: number = 0;
  lon: number = 0;
  subscriptionRegions!: Subscription;
  subscriptionDistricts!: Subscription;
  subscriptionCounties!: Subscription;
  subscriptionParishes!: Subscription;
  loadSubject$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  isView$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  postalCodeFormat = '0000-000';
  @ViewChild('formElementRef') formElementRef!: ElementRef;
  @Input()
  property: any;
  portugalCountry: any;
  defaultValues = {
    country: null,
    district: null,
    county: null,
  }

  constructor(
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private propertiesService: DevelopmentsService,
    private renderer: Renderer2,
    private permissionsService: PermissionsService,
        private translateService: TranslateService
  ) { }


  ngOnInit(): void {
    this.subscription = new Subscription();
    this.countries = this.dataToFormInitAddress.countries;
    if (this.countries)
      this.portugalCountry = this.countries?.find((c: any) => c.name === 'Portugal');
    
    this.regions = this.dataToFormInitAddress?.regions;
    this.districts = this.dataToFormInitAddress?.districts;
    this.counties = this.dataToFormInitAddress?.counties;
    this.parishes = this.filterActiveParishes(this.dataToFormInitAddress?.parishes, this.addressForm?.data?.parish);

    this.setDefaults();

    if (this.addressForm?.data?.latitude && this.addressForm?.data?.longitude) {
      this.dataToFormInitAddress.latitude = this.addressForm.data.latitude;
      this.dataToFormInitAddress.longitude = this.addressForm.data.longitude;
    }
    if (this.addressForm?.data?.country) {
      this.changeCountry({ id: this.addressForm?.data?.country }, false)
    }
    if (this.addressForm?.data?.region) {
      this.changeRegion({ id: this.addressForm?.data?.region }, false);
    }
    if (this.addressForm?.data?.district) {
      this.changeDistrict({ id: this.addressForm?.data?.district }, false);
    }
    if (this.addressForm?.data?.county) {
      this.changeCounty({ id: this.addressForm?.data?.county }, false)
    }
    this.loadSubject$.asObservable().subscribe((val) => {
      if (val === 4) {
        this.initFormValidation(this.addressForm);
        this.initMap();
        this.isView$.next(true);
      }
    })



  }
  ngAfterViewInit(): void {

    this.isView$.asObservable().subscribe(val => {
      if (val) {
        this.subscriptionSubmitted = this.eventService.subscribe('get-data-tab-address-dev', () => {
          this.addressForm.data = this.propertyAddressForm.value;
          this.addressForm.errors = this.getFormErrors();
          this.addressForm.valid = this.propertyAddressForm.valid;
          this.eventService.broadcast('ckeck-warning-add-dev');
        });

        this.propertyAddressForm.get('country')?.valueChanges.subscribe(() => {
          this.eventService.broadcast('get-data-tab-address-dev');
        });
        this.propertyAddressForm.get('region')?.valueChanges.subscribe(() => {
          this.eventService.broadcast('get-data-tab-address-dev');
        });
        this.propertyAddressForm.get('district')?.valueChanges.subscribe(() => {
          this.eventService.broadcast('get-data-tab-address-dev');
        });
        this.propertyAddressForm.get('county')?.valueChanges.subscribe(() => {
          this.eventService.broadcast('get-data-tab-address-dev');
        });
        this.propertyAddressForm.get('parish')?.valueChanges.subscribe(() => {
          this.eventService.broadcast('get-data-tab-address-dev');
        });

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          this.submitted = true;
          setTimeout(() => {
            this.setEletemtConfig();
          });

        });

      }
    })
  }

  setDefaults() {
    const c = this.countries?.find((c: any) => c.name === '---');
    const d = this.districts?.find((c: any) => c.name === '---');
    const co = this.counties?.find((c: any) => c.name === '---');
    this.defaultValues = {
      country: c?.id,
      district: d?.id,
      county: co?.id
    }
  }

  changeCountry(event: any, isChange = true) {
    if (event?.id) {
      const subR = this.propertiesService.getDataForAddressRegions(event.id).subscribe(data => {
        this.regions = data;
        const country = this.countries.find((c: any) => c.id === event?.id);
        this.postalCodeFormat = country?.postalCodeFormat ? country?.postalCodeFormat : '0000-000';
        if (isChange) {
          this.propertyAddressForm.get('region')?.reset();
          const r = this.regions.find((c: any) => c.name === '---')
          this.propertyAddressForm.patchValue({ region: r.id });
          this.changeRegion(r);
          this.setDefaults();
          this.form["zipCode"].setValue(null);
        }
        let val = this.loadSubject$.getValue();
        if (val < 4) {
          val++;
          this.loadSubject$.next(val);
        }
      });
      this.subscription.add(subR);
    }
  }

  changeRegion(event: any, isChange = true) {
    if (event?.id) {
      const subD = this.propertiesService.getDataForAddressDistrict(event.id).subscribe(data => {
        this.districts = data;
        if (isChange) {
          this.propertyAddressForm.get('district')?.reset();
          const d = this.districts.find((c: any) => c.name === '---')
          this.propertyAddressForm.patchValue({ district: d.id });
          this.changeDistrict(d);
          this.setDefaults();
        }
        let val = this.loadSubject$.getValue();
        if (val < 4) {
          val++;
          this.loadSubject$.next(val);
        }
      });
      this.subscription.add(subD);
    }
  }

  changeDistrict(event: any, isChange = true) {
    if (event?.id) {
      const subCO = this.propertiesService.getDataForAddressCounties(event.id).subscribe(data => {
        this.counties = data;
        if (isChange) {
          this.propertyAddressForm.get('county')?.reset();
          const co = this.counties.find((c: any) => c.name === '---')
          this.propertyAddressForm.patchValue({ county: co.id });
          this.changeCounty(co);
          this.setDefaults();
        }
        let val = this.loadSubject$.getValue();
        if (val < 4) {
          val++;
          this.loadSubject$.next(val);
        }
      });
      this.subscription.add(subCO);
    }
  }

  changeCounty(event: any, isChange = true) {
    if (event?.id) {
      const subP = this.propertiesService.getDataForAddressParish(event.id).subscribe(data => {
        this.parishes = this.filterActiveParishes(data, isChange ? null : this.addressForm?.data?.parish);
        if (isChange) {
          this.propertyAddressForm.get('parish')?.reset();
          const p = this.parishes.find((c: any) => c.name === '---')
          this.propertyAddressForm.patchValue({ parish: p.id });
        }
        let val = this.loadSubject$.getValue();
        if (val < 4) {
          val++;
          this.loadSubject$.next(val);
        }
      });
      this.subscription.add(subP);
    }
  }

  // Esconde freguesias desativadas, exceto a atualmente gravada no imóvel —
  // essa fica disabled (e oculta via CSS) para mostrar o valor sem ser re-selecionável
  private filterActiveParishes(list: any[], keepId: any = null): any[] {
    return (list || [])
      .filter((p: any) => p?.status !== false || p.id == keepId)
      .map((p: any) => (p?.status === false ? { ...p, disabled: true } : p));
  }

  get showOutdatedParishNotice(): boolean {
    const createdAt = this.addressForm?.data?.propertyCreatedAt;
    if (!createdAt) return false;
    const parishId = this.propertyAddressForm?.get('parish')?.value ?? this.addressForm?.data?.parish;
    const selected = this.parishes?.find((p: any) => p.id == parishId);
    const status = selected ? selected.status : this.addressForm?.data?.parishStatus;
    const deactivatedAt = selected ? selected.deactivatedAt : this.addressForm?.data?.parishDeactivatedAt;
    if (status !== false || !deactivatedAt) return false;
    return new Date(createdAt) > new Date(deactivatedAt);
  }

  /**
* Form data get
*/
  get form() {
    return this.propertyAddressForm.controls;
  }

  /**
  * Form Validation
*/
  initFormValidation(addressForm: any) {

    this.propertyAddressForm = this.formBuilder.group({
      country: [addressForm?.data?.country, [Validators.required, this.ValidateCountry]],
      region: [addressForm?.data?.region, [Validators.required, this.ValidateRegion]],
      district: [addressForm?.data?.district, [Validators.required, this.ValidateDistrict]],
      county: [addressForm?.data?.county, [Validators.required, this.ValidateCounty]],
      parish: [addressForm?.data?.parish, [Validators.required, this.ValidateParish]],
      address: [addressForm?.data?.address],
      zipCode: [addressForm?.data?.zipCode],
      doorNumber: [addressForm?.data?.doorNumber],
      fraction: [addressForm?.data?.fraction],
      floor: [addressForm?.data?.floor],
      latitude: [addressForm?.data?.latitude ? addressForm?.data?.latitude : this.dataToFormInitAddress?.latitude],
      longitude: [addressForm?.data?.longitude ? addressForm?.data?.longitude : this.dataToFormInitAddress?.longitude],
      hidePropertyAddress: [addressForm?.data?.hidePropertyAddress === true],
      hideMap: [addressForm?.data?.hideMap === true],
      hideDistrict: [addressForm?.data?.hideDistrict === true],
      hideCounty: [addressForm?.data?.hideCounty === true],
      hideParish: [addressForm?.data?.hideParish === true],
    });
  }

  ValidateCountry = (control: AbstractControl): { [key: string]: any } | null => {
    const p = this.countries?.find((p: any) => p.id == control?.value);
    if (p && p.name === '---') {
      return { 'warning': true };
    }
    return null;
  }

  ValidateRegion = (control: AbstractControl): { [key: string]: any } | null => {
    const p = this.regions?.find((p: any) => p.id == control?.value);
    if (p && p.name === '---') {
      return { 'warning': true };
    }
    return null;
  }

  ValidateDistrict = (control: AbstractControl): { [key: string]: any } | null => {
    const p = this.districts?.find((p: any) => p.id == control?.value);
    if (p && p.name === '---') {
      return { 'warning': true };
    }
    return null;
  }

  ValidateCounty = (control: AbstractControl): { [key: string]: any } | null => {
    const p = this.counties?.find((p: any) => p.id == control?.value);
    if (p && p.name === '---') {
      return { 'warning': true };
    }
    return null;
  }

  ValidateParish = (control: AbstractControl): { [key: string]: any } | null => {
    const p = this.parishes?.find((p: any) => p.id == control?.value);
    if (p && p.name === '---') {
      return { 'warning': true };
    }
    return null;
  }


  getFormErrors(): [] {
    let errors: any = [];
    Object.keys(this.propertyAddressForm.controls).forEach(key => {
      // Get errors of every form control
      let type = this.propertyAddressForm?.get(key)?.errors;
      if (type && !type['mask'])
        errors.push({ key: key, type: type });
    });
    return errors;
  }

  initMap() {
    /**
 * Basic Maps
 */
    this.options = {
      layers: [
        Leaflet.tileLayer(
          "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGV2ZGF0YWRlYnVnIiwiYSI6ImNsaWx1OGczaDA2OHEzcHB2aTVxd2Y3YjIifQ.si2wX403lhDnztGcAzBdLA",
          {
            maxZoom: 18,
            attribution:
              'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            id: "mapbox/streets-v11",
            tileSize: 512,
            zoomOffset: -1,
          }
        )
      ],
      zoom: 12,
      doubleClickZoom: false,
      center: {
        lat: this.addressForm?.data?.latitude ? this.addressForm?.data?.latitude : this.dataToFormInitAddress?.latitude,
        lng: this.addressForm?.data?.longitude ? this.addressForm?.data?.longitude : this.dataToFormInitAddress?.longitude
      }
    }

  }

  initMarkers() {
    const initialMarkers = [
      {
        position: {
          lat: this.addressForm?.data?.latitude ? this.addressForm?.data?.latitude : this.dataToFormInitAddress?.latitude,
          lng: this.addressForm?.data?.longitude ? this.addressForm?.data?.longitude : this.dataToFormInitAddress?.longitude
        },
        draggable: true
      }
    ];
    for (let index = 0; index < initialMarkers.length; index++) {
      const data = initialMarkers[index];
      const marker = this.generateMarker(data, index);
      marker.addTo(this.map);
      this.map.panTo(data.position);
      this.markers.push(marker)
    }
  }

  generateMarker(data: any, index: number) {
    return Leaflet.marker(data.position, {
      draggable: data.draggable, icon: Leaflet.icon({
        iconSize: [24, 34],
        iconAnchor: [12, 24],
        iconUrl: 'assets/images/marker-icon-2x.png',
        shadowUrl: 'assets/images/marker-shadow.png'
      })
    })
      .on('dragend', (event) => this.markerDragEnd(event, index));
  }

  onMapReady($event: Leaflet.Map) {
    this.map = $event;
    this.initMarkers();
  }

  mapDblClick($event: any) {
    this.markers[0].setLatLng($event.latlng);
    this.propertyAddressForm.patchValue({ latitude: $event.latlng.lat, longitude: $event.latlng.lng });
  }

  markerDragEnd($event: any, index: number) {
    const geo = $event.target.getLatLng();
    this.propertyAddressForm.patchValue({ latitude: geo.lat, longitude: geo.lng });
  }

  setEletemtConfig() {
    if (!this.permissionsService.checkMasterPermission('EDIT_PROPERTIES', this.property?.store?.id) && !this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'EDIT_PROPERTIES') && this.property) {
      if (this.formElementRef.nativeElement) {
        this.renderer.setStyle(this.formElementRef.nativeElement, 'pointer-events', 'none')
        const parentElement = this.formElementRef.nativeElement.parentElement;
        if (parentElement)
          this.renderer.setStyle(parentElement, 'cursor', 'not-allowed')
        const warning = parentElement.querySelectorAll('.is-warning')
        if (warning) {
          warning?.forEach((el: any) => {
            this.renderer.removeClass(el, 'is-warning')
          });
        }
      }
    }
  }

  validateLocationBtn() {
    if (!this.form['country']?.value || this.form['country']?.value == this.defaultValues.country) return false;
    if (!this.form['district']?.value || this.form['district']?.value == this.defaultValues.district) return false;
    if (!this.form['county']?.value || this.form['county']?.value == this.defaultValues.county) return false;
    if (this.form['country']?.value && this.form['country']?.value != this.defaultValues.country && this.form['country']?.value == this.portugalCountry?.id) {
      if (!this.form['address'].value) return false;
      if (!this.form['zipCode'].value) return false;
      return true;
    } else {
      if (!this.form['address'].value) return false;
      return true;
    }
  }

  refreshGeoreference() {
      if (this.form['country']?.value == this.portugalCountry?.id) {
        if (this.form['country'].value && this.form['district'].value && this.form['county'].value && this.form['address'].value && (this.form['country'].value != this.portugalCountry.id || this.form['zipCode'].value)) {
          const country = this.countries.find((c: any) => c.id === this.form['country'].value);
          const district = this.districts.find((d: any) => d.id === this.form['district'].value);
          const county = this.counties.find((c: any) => c.id === this.form['county'].value);
          this.propertiesService.refreshGeoreference(country.name, district.name, county.name, this.form['address'].value, this.form['zipCode']?.value).subscribe({
            next: data => {
              if (data && data.length > 0) {
                const lat = data[0].lat;
                const lon = data[0].lon;
                if (lat && lon) {
                  this.markers[0].setLatLng({ lat: Number(lat), lng: Number(lon) });
                  this.map.setView({ lat: Number(lat), lng: Number(lon) });
                  this.propertyAddressForm.patchValue({ latitude: Number(lat), longitude: Number(lon) });
                }
              } else {
                Swal.fire(this.translateService.instant('t-georeference-no-result'), '', 'warning');
              }
            }
          })
        }
      } else if (this.form['country']?.value && this.form['country']?.value != this.portugalCountry?.id) {
        if (this.form['country'].value && this.form['district'].value && this.form['county'].value && this.form['address'].value) {
          const country = this.countries.find((c: any) => c.id === this.form['country'].value);
          const district = this.districts.find((d: any) => d.id === this.form['district'].value);
          const county = this.counties.find((c: any) => c.id === this.form['county'].value);
          this.propertiesService.refreshGeoreferenceByQuery(country.name, district.name, county.name, this.form['address'].value).subscribe({
            next: data => {
              if (data && data.length > 0) {
                const lat = data[0].lat;
                const lon = data[0].lon;
                if (lat && lon) {
                  this.markers[0].setLatLng({ lat: Number(lat), lng: Number(lon) });
                  this.map.setView({ lat: Number(lat), lng: Number(lon) });
                  this.propertyAddressForm.patchValue({ latitude: Number(lat), longitude: Number(lon) });
                }
              } else {
                this.propertiesService.refreshGeoreferenceByQuery(country.name, district.name, county.name, '').subscribe({
                  next: data => {
                    if (data && data.length > 0) {
                      const lat = data[0].lat;
                      const lon = data[0].lon;
                      if (lat && lon) {
                        this.markers[0].setLatLng({ lat: Number(lat), lng: Number(lon) });
                        this.map.setView({ lat: Number(lat), lng: Number(lon) });
                        this.propertyAddressForm.patchValue({ latitude: Number(lat), longitude: Number(lon) });
                      }
                    } else {
                      Swal.fire(this.translateService.instant('t-georeference-no-result'), '', 'warning');
                    }
                  }
                })
              }
            }
          })
        }
      }
    }


  ngOnDestroy(): void {
    this.addressForm.data = this.propertyAddressForm.value;
    this.addressForm.errors = this.getFormErrors();
    this.addressForm.valid = this.propertyAddressForm.valid;
    this.eventService.broadcast('ckeck-warning-add-dev');
    this.subscription.unsubscribe();
    this.subscriptionSubmitted.unsubscribe();
  }

}
